import { webPortalApi } from '#config/web-portal-api';
import { FilterUserOption } from '#service/autocomplete-service/option';
import { getRequestOptions } from '#helper';

class UserFilterOptionService {
  #searchFields;

  constructor(searchFields) {
    if (!searchFields?.length) {
      throw new Error('Search fields are not provided');
    }

    this.#searchFields = searchFields;
  }

  async fetchOptionsRaw(value, fetchOptions = {}, ids) {
    const searchParams = new URLSearchParams({
      order: 'asc',
      orderBy: 'firstName',
      offset: 0,
      pagination: 1,
      limit: 50
    });

    if (value) {
      searchParams.set('filter', value);
      searchParams.set('filterBy', this.#searchFields);
    }

    if (ids) {
      searchParams.set('ids', ids);
    }

    const usersURL = webPortalApi.buildApiUrl(`user/?${searchParams.toString()}`);
    const res = await fetch(usersURL, { ...getRequestOptions(), ...fetchOptions });
    const contentType = res.headers.get('content-type');

    if (!contentType || !contentType.includes('application/json')) {
      throw new TypeError('Response is not json');
    }

    const r = res.json();

    if (!res.ok) {
      throw await r;
    }

    return r;
  }

  async getOptions(value, fetchOptions, ids) {
    const fetchedOptions = await this.fetchOptionsRaw(value, fetchOptions, ids);
    const transformedOptions = this.transformOptions(fetchedOptions);

    return transformedOptions;
  }

  transformOptions(options) {
    return options?.users?.map(option => {
      const label = `${option.firstName} ${option.lastName}`;
      return new FilterUserOption(option, label);
    });
  }
}
export default UserFilterOptionService;
